import numeral from 'numeral'

export function toNumber(value) {
    let parsedValue = numeral(value).value()/100
    return parsedValue
}